import React from "react";
import Multimedia from "@sharedComponents/multimedia";

import sampleImage from "@images/blank-image.png";
import poweredLogoImg from "@images/svg/powered-by-stadium.svg";
import style from "./purge-main.module.scss";

const NAVBAR_TEMP_DATA = [
  "FEATURED",
  "FOOD & BEVERAGES",
  "GIFT CARDS & EXPERIENCES",
  "WORK FROM HOME",
  "MERCH",
  "LIFE & HOBBIES",
  "WELLNESS",
];

const StorePreviewImage = ({
  storeName,
  logoImage,
  topBanner,
  productsThumbImage,
  noBlur = false,
  priority = false,
  className = `imgGroup ${style.imgGroup}`,
  isNavBar = false,
  isNavMenu = false,
  navBarData = NAVBAR_TEMP_DATA,
  isAnnotationActive = false,
  topBarClassName = "",
  topBannerClassName = "",
  bottomBannerClassName = "",
  parentClassName = "",
  navBarClassName = "",
  logoClassName = "",
  poweredLogo = "",
  children,
}) => {
  return (
    <div
      className={`${parentClassName} ${style.storeHeaderpreview} ${
        isAnnotationActive ? style["annotationOn"] : ""
      }`}
    >
      {isNavBar && (
        <div>
          <div className={`${style.topBar} ${topBarClassName}`}>
            <div className={`${style.logoBlock} ${logoClassName}`}>
              {logoImage ? (
                <img
                  priority={priority}
                  noBlur={noBlur}
                  src={logoImage}
                  className={style.imgLogo}
                />
              ) : (
                <span className={style.logoName}>
                  <span className={style.text}>{storeName}</span>
                </span>
              )}

              <div className={style.arrowDown} />
              <div className={`${style.poweredLogo} ${poweredLogo}`}>
                <img src={poweredLogoImg} alt="powered-by-stadium" />
              </div>
            </div>
          </div>
          {isNavMenu && (
            <div className={`${style.linkBlock} ${navBarClassName}`}>
              {navBarData.map((category) => (
                <span key={category}>{category}</span>
              ))}
            </div>
          )}
        </div>
      )}
      <div className={className}>
        <div className={`${style.topBanner} ${topBannerClassName}`}>
          <Multimedia
            type="image"
            priority={priority}
            noBlur={noBlur}
            src={topBanner || sampleImage}
            width={1200}
            height={380}
            isAnnotationActive={isAnnotationActive}
          />
        </div>
        <div className={`bottomBanner ${style.bottomBanner} ${bottomBannerClassName}`}>
          {children || (
            <Multimedia
              type="image"
              priority={priority}
              noBlur={noBlur}
              src={productsThumbImage || sampleImage}
              width={1200}
              height={580}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default StorePreviewImage;
